var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondFormat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 304,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#secondFormat_svg__clip0_632_9214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.767 59.387s-16.737-32.512 9.971-46.902c10.896-19.361 51.101-14.404 63.424 2.787 14.493 20.217 3.615 40.86 3.615 40.86l-77.005 3.255h-.005z",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.288 83.334c6.491-2.003 9.907-9.609 7.63-16.988-2.278-7.38-9.386-11.738-15.876-9.735-6.491 2.004-9.907 9.61-7.63 16.989 2.278 7.379 9.385 11.737 15.876 9.734z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.035 66.005s5.78-4.737 9.265 5.154l-9.265-5.154z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.035 66.005s5.78-4.737 9.265 5.154",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.694 78.523s-6.005-7.983-1.969-13.627l1.969 13.627z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.694 78.523s-6.005-7.983-1.969-13.627",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.764 71.865c2.277-7.38-1.138-14.985-7.629-16.988s-13.599 2.355-15.876 9.734c-2.277 7.38 1.139 14.985 7.629 16.989 6.491 2.003 13.599-2.356 15.876-9.735zM189.74 91.637s4.527 22.831-4.12 35.748c6.22 15.573 30.52 42.628 30.52 42.628l21.362-42.095s-8.848-13.328-3.428-41.145c-6.799-.444-44.334 4.864-44.334 4.864z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.979 55.103c.692 2.109 9.764 53.645 42.458 52.71 31.591-.907 30.646-60.73 30.646-60.73l-5.186-14.465-19.922-7.918-30.571 6.005-14.942 9.498v5.734",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.979 55.103c.692 2.109 9.764 53.645 42.458 52.71 31.591-.907 30.646-60.73 30.646-60.73l-5.186-14.465-19.922-7.918-30.571 6.005-14.942 9.498v5.734",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.615 314.019c-.576-25.53-5.163-129.412-41.767-162.33-24.454-21.994-71.365-28.06-71.365-28.06s-1.773 20.619-23.921 20.619c-22.149 0-23.561-21.391-23.561-21.391s-23.411 1.974-59.814 27.354c-33.891 23.631-33.77 132.208-32.989 163.808H348.62h-.004z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.076 81.891l-6.716-3.367s5.869-16.233 1.548-25.455c-2.455-5.242-10.747-10.896-21.798-1.127",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.076 81.891l-6.716-3.367s5.869-16.233 1.548-25.455c-2.455-5.242-10.747-10.896-21.798-1.127",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.572 87.564s8.236 7.922 19.011-.79l-19.011.79z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.572 87.564s8.236 7.922 19.011-.79",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.116 47.358c11.018-5.05 18.033 1.23 18.033 1.23l-18.033-1.23z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.116 47.358c11.018-5.05 18.033 1.23 18.033 1.23",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.342 59.696s7.005-7.922 15.479-.715l-15.479.715z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.342 59.696s7.005-7.922 15.479-.715",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.621 59.369s6.791-8.283 16.972-.524l-16.972.524z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.621 59.369s6.791-8.283 16.972-.524",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.808 37.523s21.012 9.835 45.415 6.197c-10.111-4.42-11.047-8.853-11.047-8.853s11.781 6.645 23.023 5.224c3.218 7.45 5.182 13.782 5.182 13.782l5.041-.73-5.817-16.48-1.88-7.001-8.17-5.977-16.948-2.048h-14.573l-10.298 1.538-13.693 4.438-7.291 11.44-1.627 4.54 2.086 12.136 1.623-.43 8.969-17.776h.005z",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.238 220.992l5.926 5.921 6.907 85.446M303.314 220.992l-5.921 5.921-3.484 85.928",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.15 64.27s-5.78-4.738-9.264 5.153l9.264-5.153z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.15 64.27s-5.78-4.738-9.264 5.153",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.485 76.789s6.005-7.983 1.969-13.628l-1.969 13.628z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.485 76.789s6.005-7.983 1.969-13.628",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.109 62.067c1.483 0 2.685-1.61 2.685-3.597 0-1.986-1.202-3.596-2.685-3.596-1.482 0-2.684 1.61-2.684 3.596s1.202 3.597 2.684 3.597zM194.161 62.576c1.482 0 2.684-1.61 2.684-3.596s-1.202-3.596-2.684-3.596c-1.483 0-2.684 1.61-2.684 3.596s1.201 3.596 2.684 3.596z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.45 214.685l4.4 58.56-3.712 47.491h24.29l3.246-48.636 2.871-66.89-31.095 9.475zM177.346 214.685l-4.401 58.56 7.085 47.491h-24.29l-6.618-48.636-2.871-66.89 31.095 9.475z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.546 75.326s-25.843 77.716 7.534 94.645h73.128c22.799-18.206 9.952-94.645 9.952-94.645H57.546z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.853 120.634c25.022 0 45.307-20.285 45.307-45.308 0-25.022-20.285-45.306-45.307-45.306-25.022 0-45.307 20.284-45.307 45.306 0 25.023 20.285 45.308 45.307 45.308z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.259 146.327c16.424-11.617 4.433-41.585 4.433-41.585-5.322 1.506-11.266-3.025-13.272-10.124-2.006-7.095.678-14.072 6.005-15.578 5.322-1.506 11.266 3.026 13.272 10.125l28.948 32.324s-6.795 16.958 2.152 25.235l-8.372 5.191a23.847 23.847 0 01-26.282-.757l-6.88-4.836-.004.005z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.503 117.028c5.467 6.992 14.478 11.243 22.069 11.243 14.254 0 22.634-15.353 22.634-34.616 0-13.67-1.59-39.167-10.064-44.886L74.84 66.254",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.503 117.028c5.467 6.992 14.478 11.243 22.069 11.243 14.254 0 22.634-15.353 22.634-34.616 0-13.67-1.59-39.167-10.064-44.886L74.84 66.254",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.057 48.768l-13.37-5.27-24.58 9.095s-2.797 1.17-4.476 7.197c-10.069 2.446-20.128 7.474-20.128 7.474L77.216 84l7.684 4.457s1.67-1.267 3.53-3.727c23.346-11.724 41.627-35.963 41.627-35.963z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.696 89.17S84.88 77.123 74.423 79.044c0 0-8.333 2.347-6.608 12.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.696 89.17S84.88 77.123 74.423 79.044c0 0-8.333 2.347-6.608 12.29M134.027 73.204s-11.112-2.53-16.27 3.615c-2.886 7.95 7.814 22.433 7.814 22.433l-5.041 5.78M110.971 75.327s-5.897-4.293-18.225-.837",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.364 84c5.458-5.247 11.238-1.459 11.238-1.459l2.652-1.08M110.986 84.002s-6.627-5.168-14.32 1.103l-3.035-.86M83.537 93.457S80.1 81.901 72.603 86.793M79.156 96.966s-4.279-7.156-1.955-11.257M124.117 110.455s-4.433 3.204-12.243 0",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.58 156.335a78.534 78.534 0 00-6.065 5.888c-6.51 7.038-11.584 15.278-15.18 24.164L6 224.291l49.086 13.164 15.503-44.049a34.85 34.85 0 00-7.455-35.416l-.542-.58c-5.308-5.658-14.156-6.163-20.011-1.066v-.009zM158.728 159.818a78.89 78.89 0 016.192 5.752c6.664 6.893 11.916 15.021 15.709 23.827l16.172 37.553-50.653 14.788-14.605-44.241a34.871 34.871 0 016.669-35.575l.533-.594c5.182-5.775 14.016-6.472 19.979-1.51h.004z",
    fill: "#35B3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.048 139.831s15.928 19.123 43.726 2.268l31.413 13.642c8.123 3.526 12.412 12.496 10.055 21.035l-20.138 83.043s-12.781 6.154-39.12 6.22c-28.583.07-40.719-6.936-40.719-6.936l-22.176-84.099c-2.764-9.335 1.79-19.282 10.662-23.29l26.297-11.883z",
    fill: "#35B3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.104 259.819l12.229-54.609",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.694 280.541c-8.727 13.604-14.933 28.509-19.287 41.856h118.604c-4.036-12.618-10.167-27.429-19.502-43.469 0-13.52-.266-19.109-.266-19.109s-43.217 12.229-79.84-.715c.36 9.872.286 21.432.286 21.432l.005.005z",
    fill: "#2963A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.265 259.108l-13.689-51.915M62.695 280.54s42.927 13.17 79.816-1.613",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.905 87.518c1.124 0 2.035-1.235 2.035-2.759 0-1.524-.911-2.759-2.035-2.759-1.123 0-2.034 1.235-2.034 2.76 0 1.523.911 2.758 2.034 2.758zM127.289 86.31c1.124 0 2.035-1.235 2.035-2.759 0-1.524-.911-2.759-2.035-2.759-1.123 0-2.034 1.235-2.034 2.76 0 1.523.911 2.758 2.034 2.758z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.912 121.482c.216.18 0 .569-.263.459-4.544-1.617-9.745-.02-12.909 3.974-.188.24-.544.03-.441-.25 1.803-4.782.526-10.033-3.21-13.108-.217-.18 0-.569.262-.459 4.544 1.617 9.745.02 12.909-3.974.188-.239.544-.03.441.25-1.803 4.782-.526 10.033 3.21 13.108zM329.873 60.358c.346.104.259.625-.108.627-6.196.172-11.739 4.183-13.783 9.946-.131.338-.65.284-.64-.09.055-6.024-3.848-11.264-9.697-13.024-.346-.104-.259-.624.108-.626 6.197-.172 11.739-4.183 13.783-9.947.131-.338.65-.283.64.09-.055 6.025 3.848 11.264 9.697 13.024zM310.872 78.724c.178-.012.235.24.057.3-2.85 1.11-4.724 3.843-4.652 6.781.008.176-.252.232-.316.068-1.04-2.732-3.762-4.446-6.796-4.27-.178.012-.234-.24-.057-.3 2.851-1.11 4.725-3.843 4.653-6.781-.009-.176.251-.232.315-.068 1.04 2.732 3.763 4.446 6.796 4.27z",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "secondFormat_svg__clip0_632_9214"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h336v304H0z"
  })))));
}
export default __webpack_public_path__ + "static/secondFormat.8e663798.svg";
export { SvgSecondFormat as ReactComponent };